export default {
    lan:'spanish',
    nav:{
        hotels:'RESORTS',
        cruisers:'CRUCEROS',
        about:'SOBRE NOSOTROS',
        contact:'Contáctanos'
    },
    aboutUs:{
        title:'Somos un negocio familiar Mexicano, el cual ofrece paquetes semanales de hospedaje hasta con un 80% de descuento en los mejores resorts de México.',
        places:'Acapulco | Riviera Maya | Mazatlán | Puerto Vallarta | Nuevo Vallarta | Los Cabos | Puerto Peñasco'
    },
    component01Video :{
        title:'Hola',
        videotextpart1:'RESERVA RESORT POR UNA SEMANA COMPLETA A',
        videotextpart2:' PRECIO DE UNA NOCHE !',
        videotextpart3:' '
    },
    component02Cruise :{
        title:'No esperes más y se de los primeros en disfrutar el nuevo crusero Vidanta',
        title02:'Vidanta Cruises: La primera línea mexicana de cruceros de lujo',
        topic:'PRESENTANDO LA PRIMERA LÍNEA MEXICANA DE CRUCEROS DE LUJO',
        description:'Ahora podras viajar y descansar a bordo con el nuevo servicio de cruceros disponibles en México.',
        places:['Información detallada sobre los itinerarios, duración de los viajes, destinos y fechas serán anunciados próximamente.'],
        reserve:'Solicitar Pre-reservación'
    },
    form:{
        cruiser:'crucero',
        hotel:'hotel',
        reservationInformation:{
            title:'Datos de la reservación de su',
            inputCity:'Cual es su destino ?',
            inputRoomType:'Tipo de habitación',
            roomsTypes: [
                'LOFT CON UNA RECÁMARA DE THE RESIDENCE',
                'LOFT CON DOS RECÁMARAS DE THE RESIDENCE',
                'LOFT CON TRES RECÁMARAS DE THE RESIDENCE',
                'THE RESIDENCE CON CUATRO RECÁMARAS',
                'MASTER ROOM DE GRAND LUXXE', 
                'SUITE CON UNA RECÁMARA DE GRAND LUXXE', 
                'SUITE CON DOS RECÁMARAS DE GRAND LUXXE',
                'VILLA JUNIOR DE GRAND LUXXE',
                'VILLA CON UNA RECÁMARA DE GRAND LUXXE',
                'SUITE PRESIDENCIAL CON UNA RECÁMARA DE GRAND LUXXE',
                'VILLA PRESIDENCIAL CON UNA RECÁMARA DE GRAND LUXXE',
                'VILLA PRESIDENCIAL CON DOS RECÁMARAS DE GRAND LUXXE',
                'VILLA PRESIDENCIAL CON TRES RECÁMARAS DE GRAND LUXXE',
                'SUITE SPA CON DOS RECÁMARAS DE GRAND LUXXE',
                'SUITE SPA CON TRES RECÁMARAS DE GRAND LUXXE',
                'LOFT DE GRAND LUXXE',
                'MASTER ROOM DE THE GRAND BLISS',
                'SUITE CON UNA RECÁMARA DE THE GRAND BLISS',
                'SUITE CON DOS RECÁMARAS DE THE GRAND BLISS',
                'MASTER ROOM DE THE GRAND MAYAN',
                'SUITE CON UNA RECÁMARA DE THE GRAND MAYAN',
                'SUITE CON DOS RECÁMARAS DE THE GRAND MAYAN',
                'MASTER ROOM DE MAYAN PALACE',
                'SUITE CON UNA RECÁMARA DE MAYAN PALACE',
                'SUITE CON DOS RECÁMARAS DE MAYAN PALACE',
            ],
            destinations:[
                'Acapulco',
                'Riviera Maya',
                'Mazatlán',
                'Puerto Vallarta',
                'Nuevo Vallarta',
                'Los Cabos',
                'Puerto Peñasco',
                'otro'
            ],
            inputPersonsNumber:'Numero de personas ?',
            inputIncommingDate:'Fecha de llegada',
            inputOutcommingDate:'Fecha de salida',
        },
        userReserver:{
            title:'Datos del reservante',
            inputName:'Nombre completo',
            inputPhone:'Teléfono',
            inputEmail:'Correo'
        },
        buttons:{
            close:'Cerrar',
            send:'Enviar'
        }
    },
    footer:{
        develop:{
            title:'Desarrollado por Connecto Software Innovations',
            subTitle:'Empresa 100% mexicana'

        },
        follow:{
            title:'Síguenos',
        }
    },
    rooms:{
        title:'Desde estilo sofisticado, hasta un sentimiento de confort pleno para disfrutar en familia, encuentre la experiencia vacacional que busca en nuestra selecta variedad de refinados hoteles resort.',
        nightPrice:'Precio del resort',
        weekPrice:'Nuestro precio',
        reserve:'Reservar'
    }
    
}
